import { SubscriptionType } from '@symon-ai/wisepipe-common';
import { UserEventType } from '../userEventType';
export const userEventSchema = {
    $id: 'urn:wisepipe-common-auth:UserEvent',
    type: 'object',
    properties: {
        userID: { type: 'string', format: 'uuid' },
        userEmail: { type: 'string' },
        name: { type: 'string' },
        eventType: {
            type: 'string',
            enum: Object.values(UserEventType)
        },
        orgID: { type: 'string', format: 'uuid' },
        integrationSource: {
            type: 'string',
            minLength: 1
        },
        integrationSourceID: { type: 'string' },
        subscriptionType: {
            type: 'string',
            enum: Object.values(SubscriptionType)
        },
        isSystemUser: { type: 'boolean' }
    },
    required: ['userID', 'userEmail', 'eventType']
};
//# sourceMappingURL=userEvent.js.map